import type { WorkspaceSummaryResponse } from '@/shared/api';
import { cn } from '@/shared/lib/cn';

/**
 * Kanalbuchungen des Kunden, aus denen keine Buchung wurde — nur die Zahl; die Liste samt
 * „Erneut verarbeiten" sieht der Workspace selbst. Sonst erführe die Plattform als Letzte, dass
 * beim Kunden Buchungen hängen. Beim Plattform-Workspace dazu die Buchungen, deren Objekt noch
 * keinem Workspace gehört: sie sieht niemand sonst. Ohne solche Buchungen bleibt die Zeile ruhig.
 */
export function WorkspaceRevisionHolds({
  workspace,
  className,
}: {
  workspace: WorkspaceSummaryResponse;
  className?: string;
}) {
  const quarantined = workspace.quarantinedRevisionCount;
  const awaiting = workspace.awaitingRevisionCount;
  const unrouted = workspace.unroutedRevisionCount;
  if (quarantined <= 0 && awaiting <= 0 && unrouted <= 0) return null;
  return (
    <p className={cn('flex flex-wrap gap-x-2 gap-y-0.5 text-xs', className)}>
      {quarantined > 0 && (
        <span className="text-sealwax font-semibold">
          {quarantined === 1
            ? '1 Kanalbuchung in Quarantäne'
            : `${quarantined} Kanalbuchungen in Quarantäne`}
        </span>
      )}
      {awaiting > 0 && <span className="text-ink-soft">{`${awaiting} wartend`}</span>}
      {unrouted > 0 && (
        <span className="text-sealwax font-semibold">
          {unrouted === 1
            ? '1 Kanalbuchung ohne Workspace'
            : `${unrouted} Kanalbuchungen ohne Workspace`}
        </span>
      )}
    </p>
  );
}
